/* eslint-disable no-console */
import saga from 'Modules/contact/store/saga'
import reducer from 'Modules/contact/store/reducer'
import { useInjectReducer, useInjectSaga } from 'Stores'
import { useDispatch, useSelector } from 'react-redux'
import { makeSelectContact } from 'Modules/contact/store/selectors'
import { getContactList, updateStatusContact } from 'Modules/contact/store/actions'

export const useContact = () => {
  useInjectSaga({ key: 'getContact', saga })
  useInjectReducer({ key: 'getContact', reducer })

  const { getContact } = useSelector(
    makeSelectContact()
  )

  const dispatch = useDispatch()
  const getContactAction = (payload) => dispatch(getContactList(payload))
  const updateStatusContactAction = (payload) => dispatch(updateStatusContact(payload))

  return {
    getContact,
    getContactAction,
    updateStatusContactAction
  }
}
